import { useStaticQuery, graphql } from "gatsby";

export interface SocialConfig {
  instagram: {
    handle: string;
  };
  facebook: {
    handle: string;
  };
  linkedin: {
    handle: string;
  };
  threads: {
    handle: string;
  };
  bluesky: {
    handle: string;
  };
  youtube: {
    handle: string;
  };
}

export const useSocialConfigData: () => SocialConfig = () => {
  const { site } = useStaticQuery(
    graphql`
      query SocialConfigQuery {
        site {
          siteMetadata {
            social {
              instagram {
                handle
              }
              facebook {
                handle
              }
              linkedin {
                handle
              }
              threads {
                handle
              }
              bluesky {
                handle
              }
              youtube {
                handle
              }
            }
          }
        }
      }
    `
  );
  return site.siteMetadata.social;
};
